import cx from 'classnames';
import React from 'react';

export interface ButtonGroupLayoutProps {
	children: React.ReactNode;
	align?: 'left' | 'center' | 'right';
	customClasses?: string;
}

export const ButtonGroupLayout = ({
	children,
	align = 'right',
	customClasses,
}: ButtonGroupLayoutProps) => (
	<div
		className={cx(
			'flex gap-(--spacing-s-nudge) [ sm:flex-row ]',
			align === 'right' ? 'flex-col-reverse justify-end' : 'flex-col',
			align === 'center' ? 'justify-center' : undefined,
			customClasses
		)}>
		{children}
	</div>
);
